
export default {
  // Service urls.
  // eslint-disable-next-line
  URL_WEB_SERVICE: __SERVER_URL__,

  ADDRESS: '',
  PHONE_NUMBER: '',
  E_MAIL: '',
};
